import { render } from "./GuideStand.vue?vue&type=template&id=f8bd06a8&scoped=true"
import script from "./GuideStand.vue?vue&type=script&lang=js"
export * from "./GuideStand.vue?vue&type=script&lang=js"

import "./GuideStand.vue?vue&type=style&index=0&id=f8bd06a8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8bd06a8"]])

export default __exports__